module.exports = __webpack_public_path__ + "img/02.b50ca16c.jpg";